import React, { ReactElement, useEffect } from 'react';
import { connect } from 'react-redux';

import { MapDto } from '../../../models';
import {
	AppState,
	AppThunkDispatch,
	MapActions,
	fetchRecentMaps,
	history
} from '../../../redux';
import { CardTemplateContainer } from '../../atoms';
import { MapCard } from '../../molecules';

export interface IRecentMapsStateProps {
	maps: MapDto[];
	fetchRecentMaps: (count: number) => void;
}

export interface IRecentMapsOwnProps {
	count: number;
}

export function RecentMapsView(
	props: IRecentMapsStateProps & IRecentMapsOwnProps
): ReactElement {
	const { maps, count, fetchRecentMaps } = props;

	useEffect(() => {
		fetchRecentMaps(count);
	}, []);

	function handleMapClick(mapId: string) {
		history.push(`map/${mapId}`);
	}

	return (
		<CardTemplateContainer columns={4}>
			{maps &&
				maps.map((map: MapDto, index: number) => (
					<MapCard
						key={index}
						big
						map={map}
						onClick={() => handleMapClick(map.id)}
					/>
				))}
		</CardTemplateContainer>
	);
}

function mapStateToProps(state: AppState) {
	return {
		maps: state.maps.maps
	};
}

function mapDispatchToProps(dispatch: AppThunkDispatch<MapActions>) {
	return {
		fetchRecentMaps: (count: number) => dispatch(fetchRecentMaps(count))
	};
}

export const RecentMaps = connect(
	mapStateToProps,
	mapDispatchToProps
)(RecentMapsView);
